import { Flex, Text, CloseIcon, IconButton, TimerIcon } from 'vvs-uikit'
import useEndOfUTCDayCountdown from 'hooks/useEndOfUTCDayCountdown'
import GotchiActionButton from 'views/VvsGotchi/components/ActionButton'
import { useTranslation } from 'contexts/Localization'

import { GachaponModalFlex, ModalTitleIcon, ModalCloseButton, CountdownLabel } from './styles'

const GachaponRedeemed: React.FC<{
  onDismiss: () => any
}> = ({ onDismiss }) => {
  const { t } = useTranslation()
  const timeExcerptMap = useEndOfUTCDayCountdown()

  return (
    <GachaponModalFlex>
      <Flex justifyContent="center">
        <ModalTitleIcon src="/images/vvsGotchi/gachapon-icon.png" />
        <ModalCloseButton>
          <IconButton variant="text" onClick={onDismiss}>
            <CloseIcon fill="black" />
          </IconButton>
        </ModalCloseButton>
      </Flex>
      <Flex p={3} flexDirection="column">
        <Flex my={2} justifyContent="space-between" alignItems="center">
          <Text color="black" fontSize="20px" fontWeight="600">
            {t('Daily Lucky Draw')}
          </Text>
          <CountdownLabel>
            <TimerIcon width="14px" fill="white" pt="2px" />
            <Text color="white" fontSize="13px" fontWeight="700" pl="3px">
              {timeExcerptMap.h > 0
                ? t('%h%h left today', timeExcerptMap)
                : timeExcerptMap.m > 0
                ? t('%m%m left today', timeExcerptMap)
                : t('%s%s left today', timeExcerptMap)}
            </Text>
          </CountdownLabel>
        </Flex>
        <Text my={3} color="black" fontSize="20px" fontWeight="400" textAlign="center">
          {t('(´∀`)')}
        </Text>
        <Text my={2} color="black" fontWeight="600">
          {t('Thanks for participating! The lucky draw will reset daily at 00:00 UTC. Please come back later!')}
        </Text>
        <GotchiActionButton mt={2} onClick={onDismiss}>
          {t('Got it!')}
        </GotchiActionButton>
      </Flex>
    </GachaponModalFlex>
  )
}

export default GachaponRedeemed
